
import type { AsyncDataOptions } from '#app';
import type { FetchOptions } from 'ofetch';
import FetchFactory from '../factory';


class UserModule extends FetchFactory<IMission[]> {
  private RESOURCE = '/user';

  async getActiveMission(
    fetchOptions?: FetchOptions<'json', string>,
    asyncDataOptions?: AsyncDataOptions<FetchResponse<IActiveMission>>
  ) {
    return useAsyncData(
      () => {
        return this.call(
          `${this.RESOURCE}/missions/get-active-mission`,
          fetchOptions
        )
      },
      asyncDataOptions
    )
  };

}

export default UserModule;
